import { useEffect } from "react";
import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  useEffect(()=>{
    const timeout = setTimeout( () => {
      window.location.replace('https://crdzandco.com/prompt-engineering/')
    }, 4000)

    return () => clearTimeout(timeout)
  },[])

  return (
    <div id="error-page" style={{position:'absolute', top:'50%',left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center'}}>
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred. </p>
      <p>It looks like the product you are looking for is missing! 😢</p>
      <p>You will be redirected soon. ⏳</p>
      <p>
        <i>Product not found!</i>
      </p>
    </div>
  );
}